/*
 * Filename: d:\projects\AutoFiFront\src\Content\CarCost\CarCost.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Friday, January 13th 2023, 2:10:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import React from "react";
import { BiInfoCircle } from 'react-icons/bi';
import { CarCostPropsType } from "Content/Car/CarCost/CarCost.type";
import styles from "Content/Car/CarCost/CarCost.module.css";
import CarCostBg from "Theme/Component/CarCost";
import CarCostSellPrice from "Theme/Component/CarCostSellPrice";
import translator from "MultiLanguage/TranslationWrapper";

function CarCost(props: CarCostPropsType) {
    const carCost = props.carCost;
    const rentalCost = Math.ceil(carCost/36);

    return (
        <React.Fragment>
            <div className={`${styles.car_costDisplay}`}>
                <CarCostBg bgColor={props.themeColor}>
                    <p className={`${styles.car_rental_cost}`}><span style={{fontSize:"1.5rem"}}>{translator.decode(carCost !== 0 ? "car.make_offer" : "car.coming_soon")}</span></p>
                    {/* <p className={`${styles.car_rental_cost}`}><span>{rentalCost}€</span>/{translator.decode("carCost.month")}</p> */}
                    {/* <div className={`${styles.tooltip}`}>
                        <span className={`${styles.tooltiptext}`}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus eum rem assumenda! Fuga esse nemo porro illum repudiandae vel corporis beatae molestias, eius sint, recusandae maiores reprehenderit, fugit autem doloremque iure nesciunt distinctio itaque. Vitae repudiandae officiis culpa ipsam dolorem eligendi, maiores temporibus ab necessitatibus animi eius neque, sapiente officia laboriosam dolor. Dolorum cum quisquam nesciunt! Aliquid ab officiis, illo molestiae vero maxime facere quidem, iusto rem deleniti necessitatibus sapiente optio nisi aliquam? Temporibus, corrupti.</span>
                        <BiInfoCircle className={`${styles.icon_info}`}/>
                    </div> */}
                </CarCostBg>
                {carCost !== 0 &&
                    <div className={`${styles.car_cost}`}>
                        <CarCostSellPrice fontColor={props.themeColor}>
                            <p className={`${styles.resetMargPad}`}>{carCost}€</p>
                        </CarCostSellPrice>
                    </div>
                }
            </div>
        </React.Fragment>
    );
}

export default CarCost;
